module.exports = __webpack_public_path__ + "static/ogbenna-f90cab21f1cb98f27f639eaecb6c76b1.png";